<template>
  <div class="employee-types">
    <img
      src="/assets/information/industry/people-group.svg"
      alt="Employee Types We Cover - Icon"
      class="mx-auto"
    />

    <FormattedHeader
      :header="employeeTypeTitle"
      :subheader="employeeTypeSubtitle"
      class="max-w-3xl mx-auto mb-10 py-4"
    />

    <div class="max-w-md md:max-w-3xl grid grid-cols-12 text-center mx-auto">
      <div
        v-for="(item, index) in employeeTypes"
        :key="`empTypes-${index}`"
        class="employee-type flex items-center justify-center col-span-12 sm:col-span-6 mx-8 my-2"
      >
        <TypeBody
          :variant="$options.Typography.Body.LARGE"
          :weight="$options.Typography.Weights.REGULAR"
          tag="p"
          class="flex-auto text-left"
          >{{ item }}</TypeBody
        >
        <img
          src="/assets/information/industry/green-shield.svg"
          class="flex-shrink-0"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api';
import { TypeBody, constants } from '@bambeehr/pollen';
import FormattedHeader from './FormattedHeader.vue';

const { Typography } = constants;

export default defineComponent({
  name: 'EmployeeTypes',
  Typography,
  components: { FormattedHeader, TypeBody },
  setup() {
    const employeeTypeTitle = `Does Bambee Cover All My Different Employees?`;
    const employeeTypeSubtitle = `Each employee comes with it’s own set of regulations and risks. We can help you get compliant with teams of any employment type.`;
    const employeeTypes = [
      'Full-Time',
      'Contractor',
      'Temporary',
      'Part-Time',
      'At Will',
      'Leased',
      'Exempt',
      'Non-Exempt',
      'Interns',
      'Seasonal',
      'Remote',
      'Term',
      'Detail',
    ];

    return {
      employeeTypeTitle,
      employeeTypeSubtitle,
      employeeTypes,
    };
  },
});
</script>
